import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updateTourSettingRes;
export const updateTourSettingTodo = createAsyncThunk('updateTourSetting', async (bool) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/update_tour_status',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "tour_status": bool,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return updateTourSettingRes = res.data
    } catch (error) {
        return updateTourSettingRes = error.response.data
    }
})